import React from "react";
import {
  Flex,
  Provider,
  Segment,
  Button,
  Image,
  Text,
} from "@fluentui/react-northstar";
import WelcomeImage from "../../../assets/images/undraw_welcome_3gvl.svg";
import Constants from "../../../constants/text-constants";
import { observer } from "mobx-react-lite";
import PropTypes from "prop-types";

const WelcomeDialog = observer((props) => {
  const { firstname, welcomeDialogComplete } = props;

  const welcomeMessage =
    "Hey" + (firstname ? " " + firstname + "!" : "!");

  const openHelpLink = () => {
    window.open(Constants.TELEWARE_HELP_LINK, "_blank");
  };

  return (
    <Provider.Consumer
      render={(theme) => (
        <Flex
          className={
            "page full-screen dialog-onboarding " +
            theme.siteVariables.themeString
          }
          data-testid="welcomeDialog"
          fill
        >
          <Segment className={"welcome-dialog-container segment " + theme.siteVariables.themeString}>          
            <Flex column hAlign="center" gap="gap.large">
              <Flex className="image-container">
                <Image
                  fluid
                  alt={WelcomeImage}
                  src={WelcomeImage}
                  className="image"
                  data-testid={"welcomeDialogImage"}
                ></Image>
              </Flex>
              <Flex column gap="gap.medium" hAlign="center">
                <Flex
                  fill
                  hAlign="center"
                  vAlign="center"
                  gap="gap.small"
                  className="title-container"
                >
                  <Text
                    size="larger"
                    weight="semibold"
                    className="title"
                    data-testid={"welcomeDialogTitle1"}
                  >
                    {welcomeMessage}
                  </Text>
                  <span className="emoji" role="img" aria-label="Waving Hand">
                    &#128075;
                  </span>
                  <Text
                    size="larger"
                    weight="semibold"
                    className="title"
                    data-testid={"welcomeDialogTitle2"}
                    content="Welcome!"
                  ></Text>
                </Flex>
                <Flex wrap hAlign="center" className="subtitle-container">
                  <Text
                    size="medium"
                    weight="regular"
                    className="subtitle"
                    data-testid={"welcomeDialogSubTitle1"}
                  >
                    {Constants.WELCOME_DIALOG_SUBTITLE1}
                  </Text>
                  <Text
                    size="medium"
                    weight="regular"
                    className="subtitle link"
                    data-testid={"welcomeDialogSubTitleLink"}
                    content={Constants.TELEWARE_HELP_LINK_DISPLAY_TEXT}
                    onClick={openHelpLink}
                  />
                  <Text
                    size="medium"
                    weight="regular"
                    className="subtitle"
                    data-testid={"welcomeDialogSubTitle2"}
                  >
                    {Constants.WELCOME_DIALOG_SUBTITLE2}
                  </Text>
                </Flex>
              </Flex>
              <Button
                content={Constants.GET_STARTED}
                primary
                onClick={welcomeDialogComplete}
                data-testid={"welcomeDialogGetStartedButton"}
              />
            </Flex>
          </Segment>
        </Flex>
      )}
    ></Provider.Consumer>
  );
});

WelcomeDialog.propTypes = {
  firstname: PropTypes.string,
  welcomeDialogComplete: PropTypes.func,
};

WelcomeDialog.defaultProps = {
  firstname: "",
};

export default WelcomeDialog;
